import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

import SearchFormFunctionalityHOC from './components/searchFormWrapper';
import RJRDatePicker from '../../components/shared/rjrDatePicker';
import SearchFormLabel from './components/searchFormLabel';
import SearchFormButtons from './components/searchFormButtons/searchFormButtons';
import SearchFormTextInput from './components/searchFormInput';
import SearchFormGroup from './components/searchFormGroup';


class SearchFormCommon extends Component {
    render() {
        return (
            <div>
                <Form>
                { (this.props.formType === '4B' || this.props.formType === '4b') &&
                        <React.Fragment>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Box" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="depositoryBoxNumber" formData={this.props.formData} /> 
                            </SearchFormGroup>                             

                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Production Date" />
                                <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="depositoryProductionDate" id="depositoryProductionDate" formData={this.props.formData} />
                            </SearchFormGroup>                    
                        </React.Fragment>
                    } 

                    { (this.props.formType === 'public') &&
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Combined Text" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="combinedText" formData={this.props.formData} /> 
                            </SearchFormGroup>
                    }

                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document ID Begin" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="documentIdBegin" formData={this.props.formData} /> 
                    </SearchFormGroup> 
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document ID End" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="documentIdEnd" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Title" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="title" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document Date" />
                        <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="documentDate" id="documentDate" formData={this.props.formData} />
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Author" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="personAuthor" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Organization Author" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="organizationAuthor" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Author" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="author" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Addressee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="personAddressee" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Organization Addressee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="organizationAddressee" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Addressee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="addressee" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Person Copyee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="personCopyee" formData={this.props.formData} /> 
                    </SearchFormGroup>                    
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Organization Copyee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="organizationCopyee" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Copyee" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="copyee" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Master Begin" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="masterBegin" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Master End" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="masterEnd" formData={this.props.formData} /> 
                    </SearchFormGroup>
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Document Type" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="documentType" formData={this.props.formData} /> 
                    </SearchFormGroup>

                    { (this.props.formType === 'public')  &&
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Other Document Type" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="otherDocumentType" formData={this.props.formData} /> 
                            </SearchFormGroup>
                    }

                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Case Name/Case Identifier" />
                        <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="caseIdentifier" formData={this.props.formData} /> 
                    </SearchFormGroup>

                    { (this.props.formType === 'privilege') &&
                        <React.Fragment>
                            <SearchFormGroup>
                                    <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Box" />
                                    <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="depositoryBox" formData={this.props.formData} /> 
                            </SearchFormGroup>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Depository Production Date" />
                                <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="depositoryProductionDate" id="depositoryProductionDate" formData={this.props.formData} />
                            </SearchFormGroup>
                        </React.Fragment>

                    }

   
                    { (this.props.formType === 'privilege' || this.props.formType === 'confidential') &&              
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Date Updated" />
                        <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="dateUpdated" id="dateUpdated" formData={this.props.formData} />
                    </SearchFormGroup>
                    }

                    { (this.props.formType === '4B' || this.props.formType === '4b') &&             
                    <SearchFormGroup>
                        <SearchFormLabel clickHandler={this.props.modalHandler} title="Date Updated" />
                        <RJRDatePicker changeHandler={this.props.dateFieldHandler} name="dateUpdated2" id="dateUpdated2" formData={this.props.formData} />
                    </SearchFormGroup>
                    }


                    { (this.props.formType === 'public')  &&
                        <React.Fragment>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Other Request Number" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="otherRequestNumber" formData={this.props.formData} /> 
                            </SearchFormGroup>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Minnesota Request Number" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="minnesotaRequestNumber" formData={this.props.formData} /> 
                            </SearchFormGroup>                           
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Mentioned Names" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="namesMentioned" formData={this.props.formData} /> 
                            </SearchFormGroup>                                                         
                        </React.Fragment>                        
                    }
                    
                    { (this.props.formType === 'privilege')  &&
                        <React.Fragment>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Privilege" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="privilege" formData={this.props.formData} /> 
                            </SearchFormGroup>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Privilege Abstract" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="privilegeAbstract" formData={this.props.formData} /> 
                            </SearchFormGroup>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Adverse Ruling" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="adverseRuling" formData={this.props.formData} /> 
                            </SearchFormGroup>
                            <SearchFormGroup>
                                <SearchFormLabel clickHandler={this.props.modalHandler} title="Court Action Numbers" />
                                <SearchFormTextInput changeHandler={this.props.textFieldHandler} id="courtActionNumber" formData={this.props.formData} /> 
                            </SearchFormGroup>                                                                                    
                        </React.Fragment>                        
                    }     

                        <SearchFormButtons searchHandler={this.props.searchHandler} clearHandler={this.props.clearFormHandler} />        

                </Form>
            </div>
        );
    }
}

export default SearchFormFunctionalityHOC((props) => ({
    
  }), SearchFormCommon);


// WEBPACK FOOTER //
// ./src/components/searchForm/searchForm_common.js